module.exports = __webpack_public_path__ + "img/CRAVATA.f6b82eb7.svg";